"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepaidTransactionToJSON = exports.PrepaidTransactionFromJSONTyped = exports.PrepaidTransactionFromJSON = exports.instanceOfPrepaidTransaction = exports.PrepaidTransactionTransactionTypeEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.PrepaidTransactionTransactionTypeEnum = {
    Credit: 'CREDIT',
    Debit: 'DEBIT'
};
/**
 * Check if a given object implements the PrepaidTransaction interface.
 */
function instanceOfPrepaidTransaction(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPrepaidTransaction = instanceOfPrepaidTransaction;
function PrepaidTransactionFromJSON(json) {
    return PrepaidTransactionFromJSONTyped(json, false);
}
exports.PrepaidTransactionFromJSON = PrepaidTransactionFromJSON;
function PrepaidTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transactionId': !(0, runtime_1.exists)(json, 'transaction_id') ? undefined : json['transaction_id'],
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'transactionMicroAmount': !(0, runtime_1.exists)(json, 'transaction_micro_amount') ? undefined : json['transaction_micro_amount'],
        'transactionType': !(0, runtime_1.exists)(json, 'transaction_type') ? undefined : json['transaction_type'],
        'offerMicroAmount': !(0, runtime_1.exists)(json, 'offer_micro_amount') ? undefined : json['offer_micro_amount'],
        'taxMicroAmount': !(0, runtime_1.exists)(json, 'tax_micro_amount') ? undefined : json['tax_micro_amount'],
        'balanceMicroAmount': !(0, runtime_1.exists)(json, 'balance_micro_amount') ? undefined : json['balance_micro_amount'],
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
        'created': !(0, runtime_1.exists)(json, 'created') ? undefined : (new Date(json['created'])),
        'externalGatewayPaymentId': !(0, runtime_1.exists)(json, 'external_gateway_payment_id') ? undefined : json['external_gateway_payment_id'],
    };
}
exports.PrepaidTransactionFromJSONTyped = PrepaidTransactionFromJSONTyped;
function PrepaidTransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transaction_id': value.transactionId,
        'ad_account_id': value.adAccountId,
        'transaction_micro_amount': value.transactionMicroAmount,
        'transaction_type': value.transactionType,
        'offer_micro_amount': value.offerMicroAmount,
        'tax_micro_amount': value.taxMicroAmount,
        'balance_micro_amount': value.balanceMicroAmount,
        'currency_code': value.currencyCode,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'external_gateway_payment_id': value.externalGatewayPaymentId,
    };
}
exports.PrepaidTransactionToJSON = PrepaidTransactionToJSON;
